var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "accordion" }, [
    _c(
      "div",
      { staticClass: "accordion__title", on: { click: _vm.toggleAccordion } },
      [
        _c(
          "span",
          [
            _c("ag-icon", {
              style: {
                transform: _vm.isOpen ? "rotate(180deg)" : "rotate(0deg)",
              },
              attrs: { icon: "chevron-down" },
            }),
            _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "textContent",
        staticClass: "accordion__text",
        class: { "accordion__text--selected": _vm.isOpen },
        style: {
          maxHeight: _vm.isOpen ? _vm.maxHeight + "px" : "0",
          marginTop: _vm.isOpen ? "20px" : "0",
        },
      },
      [_vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }